import { render } from "./TemplateRenderer.vue?vue&type=template&id=42e92f9c"
import script from "./TemplateRenderer.vue?vue&type=script&lang=js"
export * from "./TemplateRenderer.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__